import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';
import { ISelectOption } from 'common/components/MultipleSelect/MultipleSelect';
import { IEmployeeProfileDto } from 'common/interfaces/employee';

export function makeEmployeeLabel(employee: IEmployeeBasicInfo): string {
  const employeeIdentifier = employee.employeeIdentifier;
  const fulName = `${employee.firstName} ${employee.lastName}`;

  return employeeIdentifier ? `${employeeIdentifier} - ${fulName}` : fulName;
}

export function makeEmployeeOption(employee: IEmployeeBasicInfo): ISelectOption {
  return {
    id: employee.id.toString(),
    title: makeEmployeeLabel(employee),
    name: `${employee.firstName} ${employee.lastName}`,
  };
}

export function makeEmployeeOptions(employees: IEmployeeBasicInfo[]): ISelectOption[] {
  return employees.map(makeEmployeeOption);
}

export function makeSalespersonOptions(employees: IEmployeeBasicInfo[]): ISelectOption[] {
  return employees.map(employee => ({
    id: employee.id.toString(),
    title: makeEmployeeLabel(employee),
    name: `${employee.firstName} ${employee.lastName}`,
    imageUrl: employee.imageUrl || undefined,
  }));
}

export function makeEmployeeFullName(employee: IEmployeeProfileDto): string {
  const nameParts: string[] = [];

  if (employee.firstName) {
    nameParts.push(employee.firstName);
  }

  if (employee.lastName) {
    nameParts.push(employee.lastName);
  }

  if (employee.preferredName) {
    nameParts.push(`(${employee.preferredName})`);
  }

  return nameParts.join(' ');
}
